<template lang="pug">
section.visualizar-territorio
    .dados
        header
            h1
                i.el-icon-arrow-left.back(@click='goToTerritorio()')
                | {{ $t('mensagens.territorio.labels.territorio') }}
        .mb2(v-if='territorio')
            p
                b {{ $t('mensagens.territorio.labels.nome') }}:
                |
                | {{ territorio.nome }}
            p
                b {{ $t('mensagens.territorio.labels.areaHa') }}:
                |
                | {{ formatNumber(territorio.areaHa) }}
            p
                b {{ $t('mensagens.territorio.labels.localidade') }}:
                |
                | {{ territorio.localidade }}
            p(v-if='territorio.certificacoes.length')
                b {{ $t('mensagens.territorio.labels.certificacoes') }}:
                |
                | {{ nomesCertificacoes }}
            p
                b {{ $t('mensagens.territorio.labels.dataDeCadastro') }}:
                |
                | {{ territorio.dataCadastroFormatada }}
            p(v-if='territorio.dataAtualizacao')
                b {{ $t('mensagens.territorio.labels.dataDaUltimaAtualizacao') }}:
                |
                | {{ territorio.dataAtualizacaoFormatada }}
            p(v-if='permissaoAmbiente(ambientes.PARAGUAY)')
                b {{ $t('mensagens.territorio.labels.padron') }}:
                |
                | {{ isValidValue(territorio.padron) ? territorio.padron : '-' }}

            p(v-if='permissaoAmbiente(ambientes.PARAGUAY)')
                b {{ $t('mensagens.territorio.labels.finca') }}:
                |
                | {{ isValidValue(territorio.finca) ? territorio.finca : '-' }}

        hr

        el-collapse(
            v-model='collapseDadosTerritorioAtivo',
            @change='handleChangeCollapse',
            accordion
        )
            el-collapse-item(name='REPRESENTANTE')
                template(slot='title')
                    .titulo-collapse
                        i.flow.flow-user-second
                        |
                        | {{ $t('mensagens.territorio.labels.pessoas') }}
                .container-dados-collapse
                    div(v-if='representantes.length')
                        .representante.mb2(
                            v-for='representante in representantes'
                        )
                            p
                                b {{ $t('mensagens.territorio.labels.nome') }}:
                                |
                                | {{ representante.nomeRazaoSocial }}

                            p
                                b {{ $t('mensagens.territorio.labels.documento') }}:
                                |
                                | {{ numeralStringFormatTocpfCnpj(representante.cpfCnpj) }}

                            p(v-if='representante.email')
                                b {{ $t('mensagens.territorio.labels.email') }}:
                                |
                                | {{ representante.email }}
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )

            el-collapse-item(
                name='CAR',
                v-if='!permissaoAmbiente(ambientes.PARAGUAY) && !permissaoAmbiente(ambientes.ARGENTINA)'
            )
                template(slot='title')
                    .titulo-collapse
                        i.flow.flow-shape
                        |
                        | {{ $t('mensagens.territorio.labels.cars') }}
                .container-dados-collapse
                    div(v-if='cars.length > 0')
                        el-table#tabelas-collapse(
                            :data='cars',
                            style='width: 100%'
                        )
                            el-table-column
                                template(slot='header', slot-scope='scope')
                                    span {{ $t('mensagens.territorio.labels.codigo') }}
                                template(slot-scope='scope')
                                    span {{ scope.row.codigo }}
                            el-table-column(width='90')
                                template(slot='header', slot-scope='scope')
                                    span {{ $t('mensagens.territorio.labels.condicao') }}
                                template(slot-scope='scope')
                                    span {{ scope.row.condicao }}
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )
            el-collapse-item(
                name='INFORMACAO',
                v-if='permissaoAmbiente(ambientes.PARAGUAY)'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-briefcase-arrow-up-down-outline
                        |
                        | {{ $t('mensagens.territorio.information.titulo') }}
                .container-dados-collapse
                    div(v-if='territorio?.informacaoAgricolaPY?.length > 0')
                        el-table#tabelas-collapse(
                            :data='territorio.informacaoAgricolaPY',
                            style='width: 100%'
                        )
                            el-table-column(
                                prop='nome',
                                :label='$t("mensagens.territorio.information.cultivo")'
                            )
                            el-table-column(
                                prop='areaPlantada',
                                :label='$t("mensagens.territorio.information.area")'
                            )

            el-collapse-item(
                v-if='usuarioLogado.historicoMonitoramentoAccess',
                name='HISTORICO_AGRICOLA'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-history
                        |
                        | {{ $t('mensagens.territorio.historicoAgricola') }}

                .container-dados-collapse
                    div(v-if='historicos.length')
                        el-table#tabelas-collapse(
                            @cell-mouse-enter='tabelaHistoricoAgricolaHover',
                            @cell-mouse-leave='tabelaHistoricoAgricolaLeaver',
                            :data='historicos',
                            style='width: 100%'
                        )
                            el-table-column(
                                :label='$t("mensagens.territorio.labels.ciclo")'
                            )
                                template(slot-scope='scope')
                                    span {{ scope.row.codigoAnoSafra }}
                            el-table-column(
                                prop='codigoCultura',
                                :label='$t("mensagens.territorio.labels.cultura")'
                            )
                            el-table-column(width='110')
                                template(slot='header', slot-scope='scope')
                                    .text-align-right
                                        span {{ $t('mensagens.territorio.labels.produtividade') }}
                                template(slot-scope='scope')
                                    .text-align-right
                                        span {{ scope.row.produtividadeKgHa }}
                            el-table-column(width='110')
                                template(slot='header', slot-scope='scope')
                                    .text-align-right
                                        span {{ $t('mensagens.territorio.labels.areaPlantada') }}
                                template(slot-scope='scope')
                                    .text-align-right
                                        span {{ scope.row.areaHa }}
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )

            el-collapse-item(
                v-if='!territorio?.internacional',
                name='DIAGNOSTICO_SOCIOAMBIENTAL'
            )
                template(slot='title')
                    .titulo-collapse
                        i.mdi.mdi-clipboard-pulse-outline
                        |
                        | {{ $t('mensagens.territorio.labels.diagnosticoAmbiental') }}

                .container-dados-collapse
                    div(v-if='diagnosticoSocioambientalTerritorio')
                        DiagnosticoSocioambiental(
                            v-if='refMapa',
                            :dadosConsulta='diagnosticoSocioambientalTerritorio',
                            @index-aberto='mostrarRestricaoTerritorio',
                            :mapaLeaflet='refMapa',
                            :habilitar-zoom-restricao='true'
                        )
                    .container-nenhum-resultado-collapse(v-else)
                        el-empty(
                            :description='$t("mensagens.comuns.erros.nenhumResultadoEncontrado")'
                        )

    mapa.mapa(
        :mapLayersConfigs='layersMaps',
        :mapConfig='mapConfig',
        :height='"100%"',
        :idMapa='"mapaTerritorio"',
        ref='mapa',
        :atualizarMapa='true',
        :menuMaior='true'
    )
</template>

<script>
import territorioService from '@/services/TerritorioService';

import Mapa from '@/components/MapaLeaflet.vue';
import formatters from '@/utils/formatters';
import { getEstiloGeometria } from '@/utils/mapa/mapa.estilos';
import { mapState } from 'vuex';
import HistoricoService from '@/services/HistoricoService';
import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';
import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import { AmbientesEmpresas } from '@/constants/AmbienteLogado.js';

export default {
    name: 'VisualizarTerritorio',
    components: {
        Mapa,
        DiagnosticoSocioambiental
    },
    data() {
        return {
            idTerritorio: this.$route.params.idTerritorio,
            territorio: null,
            representantes: [],
            cars: [],
            comercializacoes: [],
            layersMaps: [],
            mapConfig: {
                controls: {
                    zoomControl: true,
                    camadasControl: true
                }
            },
            historicos: [],
            collapseDadosTerritorioAtivo: '',
            tabelaHistoricoRowSelecionada: null,
            nomesCertificacoes: '',
            diagnosticoSocioambientalTerritorio: null,
            refMapa: null,
            ambientes: AmbientesEmpresas
        };
    },
    computed: {
        ...mapState(['usuarioLogado'])
    },
    mounted() {
        this.fetchTerritorio();
        this.refMapa = this.$refs.mapa;
    },
    methods: {
        permissaoAmbiente(ambiente) {
            return this.usuarioLogado.ambienteLogado === ambiente;
        },
        async fetchTerritorio() {
            const { data } = await territorioService.findById(
                this.idTerritorio
            );
            this.territorio = data;
            this.cars = this.territorio.cars;
            this.representantes = this.territorio.representantes;
            if (this.usuarioLogado.ambienteLogado === 'AR') {
                this.comercializacoes = this.territorio.informacaoAgricolaPY;
            }
            if (
                this.territorio.comercializacoes != null &&
                this.usuarioLogado.ambienteLogado !== 'AR'
            ) {
                this.comercializacoes = this.territorio.comercializacoes;
                this.comercializacoes.forEach(c => {
                    c.quantidade = formatters.formatNumber(c.quantidade);
                    c.info =
                        ' - ' +
                        c.quantidade +
                        ' (' +
                        c.unidadeMedida.simbolo +
                        ')';
                });
            }
            if (this.territorio.certificacoes != null) {
                this.territorio.certificacoes.forEach(c => {
                    if (this.nomesCertificacoes.length > 0) {
                        this.nomesCertificacoes += ', ';
                    }
                    this.nomesCertificacoes += c.nome;
                });
            }
            this.configureLayersMapa();
        },
        traducaoValores() {
            const valorTraduzido = this.$t(
                'mensagens.territorio.comercializacao'
            );

            this.comercializacoes = this.territorio.comercializacoes.map(c => {
                const produtoLowerCase = c.produto.codigo
                    .toLowerCase()
                    .replace(/_./g, match => match.charAt(1).toUpperCase());
                const unidadeMedidaLowerCase = c.unidadeMedida.codigo
                    .toLowerCase()
                    .replace(/_./g, match => match.charAt(1).toUpperCase());

                const nomeProdutoTraduzido =
                    valorTraduzido[produtoLowerCase] || c.produto.nome;
                const unidadeMedidaTraduzido =
                    valorTraduzido[unidadeMedidaLowerCase] ||
                    c.unidadeMedida.nome;

                return {
                    ...c,
                    produto: {
                        ...c.produto,
                        nome: nomeProdutoTraduzido
                    },
                    unidadeMedida: {
                        ...c.unidadeMedida,
                        nome: unidadeMedidaTraduzido
                    },
                    quantidade: formatters.formatNumber(c.quantidade),
                    info: ` - ${formatters.formatNumber(c.quantidade)} (${
                        c.unidadeMedida.simbolo
                    })`
                };
            });
        },
        configureLayersMapa() {
            this.layersMaps = [];

            let layerTerritorio = {
                style: getEstiloGeometria('area'),
                name: 'Território',
                geoJson: this.territorio.geometria
            };

            this.layersMaps.push(layerTerritorio);
        },
        numeralStringFormatTocpfCnpj(valor) {
            return formatters.numeralStringFormatTocpfCnpj(valor, this.usuarioLogado.ambienteLogado);
        },
        formatNumber(number) {
            return number
                ? Number(number).toLocaleString('pt-br', {
                      minimumFractionDigits: 4
                  })
                : '-';
        },
        isValidValue(value) {
            return (
                value !== null &&
                value !== undefined &&
                value !== 'null' &&
                value !== ''
            );
        },
        goToTerritorio() {
            if (this.usuarioLogado.ambienteLogado === 'AR') {
                this.$router.push({ name: 'TerritorioArgentina' });
            } else {
                this.$router.push({ name: 'Territorio' });
            }
        },
        async handleChangeCollapse() {
            switch (this.collapseDadosTerritorioAtivo) {
                case 'HISTORICO_AGRICOLA':
                    await this.buscarHistoricoAgricola();
                    break;

                case 'DIAGNOSTICO_SOCIOAMBIENTAL':
                    await this.buscarDiagnosticoSocioambiental();
                    break;
                default:
                    break;
            }
        },
        async buscarHistoricoAgricola() {
            const { data } = await HistoricoService.buscarAgricola(
                JSON.stringify(this.territorio.geometria)
            );
            this.historicos = data;
        },

        async buscarDiagnosticoSocioambiental() {
            const { data } = await DiagnosticoSocioambientalService.buscarPorId(
                JSON.stringify(this.territorio.diagnosticoSocioambiental.id)
            );
            this.diagnosticoSocioambientalTerritorio = {
                diagnostico: JSON.parse(data.resultado)
            };
        },

        mostrarRestricaoTerritorio(_, __, indexCamada) {
            this.layersMaps = [];

            this.layersMaps.push({
                style: getEstiloGeometria('area'),
                name: 'Território',
                geoJson: this.territorio.geometria
            });

            if (indexCamada) {
                this.diagnosticoSocioambientalTerritorio.diagnostico[
                    indexCamada
                ].resultados.forEach((restricao, index) => {
                    this.layersMaps.push({
                        style: getEstiloGeometria('restricao'),
                        name: `restricaoTerritorio_${indexCamada}_${index}`,
                        geoJson: restricao.geometry
                    });
                });
            }
        },

        tabelaHistoricoAgricolaHover(row) {
            let layerTerritorio = {
                style: getEstiloGeometria('historicoAgricola'),
                name: 'Histórico',
                geoJson: row.geometria
            };

            this.layersMaps = [...this.layersMaps, layerTerritorio];
        },
        tabelaHistoricoAgricolaLeaver() {
            this.layersMaps = this.layersMaps.filter(
                l => l.name !== this.$t('mensagens.territorio.labels.historico')
            );
        }
    }
};
</script>

<style lang="scss">
.visualizar-territorio {
    padding: 20px;
    height: 100%;
    width: 100%;
    display: flex;
}

header {
    grid-area: header;
    margin-bottom: 30px;

    h1 {
        line-height: 1;
    }
}

.dados {
    width: 400px;
    background-color: var(--white);

    padding: 16px;
    border-radius: 5px 0 0 5px;

    overflow: auto;

    .mb1 {
        margin-bottom: 15px;
        margin-top: 20px;
    }

    .mb2 {
        margin-bottom: 32px;
    }

    p {
        line-height: 1;
    }

    .el-collapse-item__content {
        padding-bottom: 0 !important;
    }
}

.mapa {
    grid-area: mapa;
    width: 100%;
    border-radius: 0 5px 5px 0;
    overflow: hidden;
}

.back {
    cursor: pointer;
    line-height: 2;
}

.titulo-collapse {
    font-size: 18px;
    font-weight: normal;
}

.container-dados-collapse {
    margin-top: 15px;
}

.container-nenhum-resultado-collapse {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    i {
        color: #a7a7a7;
        font-size: 30px;
    }
}

#tabelas-collapse {
    font-size: 14px;
    color: var(--primary-font-color);

    tr:nth-child(odd) {
        background-color: var(--selected-background-color);
    }
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    font-weight: 500 !important;
    font-size: 14px !important;
    color: var(--primary-font-color) !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td {
    border: none !important;
}

#tabelas-collapse
    > div.el-table__body-wrapper.is-scrolling-none
    > table
    > tbody
    > tr
    > td
    > .cell
    > span {
    word-break: break-word;
}

#tabelas-collapse > div.el-table__header-wrapper > table > thead > tr > th {
    border: none !important;
}

.text-align-right {
    text-align: right;
}

.item-list-row {
    display: grid;
    grid-template-columns: auto auto auto;
    width: 100%;
    column-gap: 10px;
}

.custom-divider {
    margin-bottom: 1px !important;
    margin-top: -12px !important;
}
</style>
